<span class="accordion-label text-b2-m-700"><ng-content></ng-content></span>
<sd-icon class="icon-size-m" [type]="opened() ? iconTypes.MINUS : iconTypes.PLUS"></sd-icon>
